export default "__VITE_ASSET__CfyhwsQH__"